<template>
  <div>
    <SGPFlowTimelineComponent :items="parseTimelineData"></SGPFlowTimelineComponent>
    <div class="text-center">
      <SGPFormBotaoComponent
        v-if="items.total > 9 && items.current_page < items.last_page"
        small @click="carregarMais"
        color="primary" class="mt-3 mb-3 text-center"
      >
        Carregar mais
      </SGPFormBotaoComponent>
    </div>
  </div>  
</template>

<script>
import moment from 'moment'
import SGPFlowTimelineComponent from './SGPFlowTimelineComponent.vue'
import SGPFormBotaoComponent from '../../../../../common/sgp-components/SGPFormBotaoComponent.vue'
import { mapActions } from 'vuex'
export default {
  name: "FlowTimelineComponent",
  components: {
    SGPFlowTimelineComponent,
    SGPFormBotaoComponent
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    pco_tarefa_atual: {
      type: Number,
      required: true
    },
    circuito: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      listaDeTimeline: [],
    }
  },

  computed: {
    parseTimelineData () {
      const { data } =  this.$props.items
      let tarefasAbertas = []
      let tarefasPercorridas = []

      data.map(item => {
        if (item.finalized_at) {
          tarefasPercorridas.push(item)
        } else {
          tarefasAbertas.push(item)
        }
      })

      tarefasPercorridas = tarefasAbertas.concat(tarefasPercorridas)
      
      tarefasPercorridas.sort((a, b) => {
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        return dateB - dateA;
      });

      return tarefasPercorridas.map((item, index) => {
        return {
          data_cadastro: item.created_at ? moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') : '',
          data_finalizacao: item.finalized_at ? moment(item.finalized_at).format('DD/MM/YYYY HH:mm:ss') : '',
          usuario_fechamento: item.pco_tarefa.pco_tratamento_fechamento?.user_cadastro ? item.pco_tarefa.pco_tratamento_fechamento.user_cadastro.name : '',
          user_cadastro: index && data[index-1].pco_tarefa.ctrl_tipo_tarefa_id == 2 ? this.verificaUserCadastro(data[index-1].pco_tarefa.user_cadastro) : null,
          usuario_tarefa: item.pco_tarefa.user_tratamento ? item.pco_tarefa.user_tratamento.name : '',
          content: `${item.pco_tarefa.ctrl_tarefa?.map || ''} - ${item.pco_tarefa.ctrl_tarefa?.tarefa || ''}`,
          line: item.pco_tarefa.ctrl_tipo_tarefa_id == 1 ? false : true,
          pco_tarefa_id: item.pco_tarefa.id,
          pco_tarefa_atual: parseInt(this.$props.pco_tarefa_atual),
          aging_minutos: item.pco_tarefa.aging_minutos,
          aging_dias: `${item.aging_dias_formatado} ${item.aging_minutos_formatado.substr(-4, 4).replace(':', 'h')}min` ,
          pco_status: item.id,
          stopped: item.pco_tarefa.pco_tarefa_interrupcao_id ? index : null
        }
      })
    },

    paginacao (){
      return {
        pco_circuito_id: this.$props.circuito.id,
        per_page: 10,
        current_page: 1,
        last_page: null
      }
    }
  },
  methods: {
    ...mapActions('fichaTecnicaWorflow', [
      'listarCircuitoPcoTarefasLog'
    ]),
    carregarMais () {
      this.paginacao.per_page = this.$props.items.per_page
      this.paginacao.current_page += 1

      this.listarCircuitoPcoTarefasLog(this.paginacao)
    },

    verificaUserCadastro (user) {
      if (user) {
        return user.name
      }
      return null
    }
  }
}
</script>